module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub--.1bd517de.svg";